import React, { PureComponent, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import Join from 'components/student_join/student_join'
import { GoogleLoginButton, Office365LoginButton } from 'components/button'

import styles from './view.scss'

class SignupStudent extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<h1 styleName='title'>{localize('signup_student_title')}</h1>
				{ this.props.shouldShowSso &&
					<Fragment>
						<h2 styleName='subtitle'>{localize('logIn_subtitle')}</h2>
						<div styleName='button'>
							<GoogleLoginButton
								onSuccess={this.props.googleLoginSuccess}
								onFailure={this.props.googleLoginFailed}
							/>
						</div>
						<div styleName='button'>
							<Office365LoginButton
								onSuccess={this.props.office365LoginSuccess}
								onFailure={this.props.office365LoginFailed}
							/>
						</div>
						<p styleName='separator'>{localize('signup_teacher_separator')}</p>
					</Fragment>
				}
				<h2 styleName='subtitle'>{localize('signup_student_subtitle')}</h2>
				<div styleName='join'>
					<Join color={this.props.shouldShowSso ? 'cerulean' : 'blue'} />
				</div>
				<p styleName='text'>
					{localize('signup_student_text_part1')}<br />
					{localize('signup_student_text_part2')}
					<strong styleName='text-strong'>
						{localize('signup_student_text_part3')}
					</strong>
				</p>
			</div>
		)
	}
}

SignupStudent.propTypes = {
	shouldShowSso: PropTypes.bool,
	googleLoginSuccess: PropTypes.func,
	googleLoginFailed: PropTypes.func,
	office365LoginSuccess: PropTypes.func,
	office365LoginFailed: PropTypes.func,
}

SignupStudent.defaultProps = {
	shouldShowSso: false,
	googleLoginSuccess: () => {},
	googleLoginFailed: () => {},
	office365LoginSuccess: () => {},
	office365LoginFailed: () => {},
}

export default CSSModules(SignupStudent, styles, {allowMultiple: true})
